export const conditionTypes = [
  { id: 'contact-data', text: 'Данные контакта' },
];
